import React, { useEffect, useState, useRef } from 'react';
import { apiFetch } from '../api';

const Interests = () => {
  const [interests, setInterests] = useState([]);
  const [input, setInput] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const fetchInterests = async () => {
      try {
        const res = await apiFetch('/api/interests');
        if (res.ok) {
          const data = await res.json();
          setInterests(Array.isArray(data.interests) ? data.interests : []);
        }
      } catch (e) {
        // Silent fail; widget remains usable locally
      }
    };
    fetchInterests();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const persist = async (next) => {
    try {
      await apiFetch('/api/interests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ interests: next })
      });
    } catch (e) {
      // Ignore network errors in UI; state remains local
    }
  };

  const addInterest = (value) => {
    const v = (value || '').trim();
    if (!v) return;
    const exists = interests.some(i => i.toLowerCase() === v.toLowerCase());
    if (exists) return;
    const next = [...interests, v].slice(0, 12); // cap to 12
    setInterests(next);
    persist(next);
    setInput('');
  };

  const removeInterest = (value) => {
    const next = interests.filter(i => i !== value);
    setInterests(next);
    persist(next);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addInterest(input);
    } else if (e.key === 'Backspace' && !input && interests.length) {
      removeInterest(interests[interests.length - 1]);
    }
  };

  return (
    <div ref={containerRef} className="lrbrain-interests">
      <button
        onClick={() => setOpen(o => !o)}
        title="Set interests to tailor practice"
        className="lrbrain-interests-button"
      >
        ⭐ Interests
      </button>
      {open && (
        <div className="lrbrain-interests-panel">
          <div className="lrbrain-interests-header">
            <div className="title">Tailor with Interests</div>
            <button className="close" aria-label="Close" onClick={() => setOpen(false)}>×</button>
          </div>
          <div className="subtitle">Add interests to personalize examples and practice.</div>

          {!!interests.length && (
            <div className="chips">
              {interests.map((i) => (
                <span key={i} className="chip">
                  {i}
                  <button className="remove" onClick={() => removeInterest(i)} title="Remove">×</button>
                </span>
              ))}
            </div>
          )}

          <div className="input-row">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={onKeyDown}
              placeholder="e.g., basketball, coding, anime"
              className="lrbrain-interests-input"
            />
            <button className="add" onClick={() => addInterest(input)}>Add</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Interests;
